import React from 'react'


import { Box } from '@mui/material';

const BoxReferencia = ({ titulo, valor, recomendacion1, icoRecomendacion1, recomendacion2, icoRecomendacion2, recomendacion3, icoRecomendacion3, bgColor }) => {

    return (
        <Box

            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                width: '14rem',
                fontFamily: 'Roboto',
                backgroundColor: bgColor,
                position: 'relative',

                '@media (max-width: 500px)': {

                    width: '100%',
                    padding: '1rem',
                    margin: '0',
                    height: 'auto',

                    '& > div > p': {
                        marginY: '0.5em',
                        paddingY: '0',
                        gap: '1em',

                    },

                }
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    width: '100%',
                    flexWrap: 'nowrap',
                }}>
                <Box
                    style={{
                        flex: 1,
                        paddingLeft: '0.2rem',
                    }}
                >
                    <img
                        style={{
                            width: 'auto',
                            maxHeight: '6rem',
                        }}
                        src={`${process.env.PUBLIC_URL}/assets/logo_uv.png`} alt="Logo UV" />
                </Box>


                <Box
                    style={{
                        flex: 1,
                        display: 'flex',
                        flexGrow: 1,
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        paddingRight: '0.5rem',
                        fontSize: '2em',
                        fontWeight: 'normal',
                    }}
                >
                    <h3
                        style={{
                            margin: 0,
                        }}
                    >{valor}</h3>
                </Box>
            </Box>
            <Box

                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    whiteSpace: 'pre',

                    gap: '0.4rem',
                    ' & > div': {
                        height: { xs: '5rem', sm: '3rem' },
                        justifyContent: 'center',
                        alignItems: 'center',
                        display: 'flex',

                    },

                    ' & > div > img': {
                        width: 'auto',
                        maxHeight: '100%',
                        maxWidth: '70%',
                    },
                    ' & > p': {
                        fontSize: '0.9rem',
                    },




                }}
            >
                {
                    (titulo.length < 10)
                        ? <p style={{ fontSize: '1.5rem', }}>{titulo}</p>
                        : <p style={{ fontSize: '1rem', }}>{titulo}</p>
                }

                <Box

                >

                    {icoRecomendacion1 && <img src={`${process.env.PUBLIC_URL}/assets/${icoRecomendacion1}`} alt="Imágen primera recomendación" />}
                </Box>
                <p>{recomendacion1}</p>


                <Box

                >
                    {icoRecomendacion2 && <img src={`${process.env.PUBLIC_URL}/assets/${icoRecomendacion2}`} alt="Imágen primera recomendación" />}
                </Box>
                <p>{recomendacion2}</p>

                <Box
                >
                    {icoRecomendacion3 && <img src={`${process.env.PUBLIC_URL}/assets/${icoRecomendacion3}`} alt="Imágen primera recomendación" />}
                </Box>
                <p>{recomendacion3}</p>

            </Box>
            <Box
                sx={{
                    position: 'absolute',
                    height: '100%',
                    width: '100%',
                    left: { xs: '10%', sm: '-2em' },
                    margin: '0 auto',
                    bottom: { xs: '-60%', sm: '-50%' },



                }}>


                <img

                    style={{
                        filter: 'brightness(0.35) ',
                        opacity: '0.2',
                        transform: 'rotate(270deg)',
                    }}
                    src={`${process.env.PUBLIC_URL}/assets/logo_inumet.svg`} alt="Logo INUMET" />
            </Box>

        </Box>
    )
}

export default BoxReferencia
